import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-data-cdt',
  templateUrl: './maintenance-data-cdt.component.html',
  styleUrls: ['./maintenance-data-cdt.component.sass']
})
export class MaintenanceDataCDTComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
